import moment from 'moment';

const MAX_DVIR_IMAGE_SIZE = 5 * 1024 * 1024;

export default {
  details: [
    {
      name: 'ownershipType',
      label: '160 Owned or Leased',
      component: 'viewOnly'
    },
    {
      name: 'inspectionDate',
      label: 'Date',
      component: 'viewOnly',
      format: value => (value ? moment(value).parseZone().format('MM/DD/YYYY') : '')
    },
    {
      name: 'yardName',
      label: 'Location',
      component: 'viewOnly'
    },
    {
      name: 'inspectionType',
      label: 'Inspection Type',
      component: 'viewOnly'
    },
    { name: 'odometerReading', label: 'Odometer Reading', component: 'input' }
  ],
  noDefects: [{ name: 'noDefects', label: 'No defects noted', component: 'checkbox' }],
  driver: [
    { name: 'remarks', label: 'Remarks', component: 'textarea', props: { rows: 3 } },
    {
      name: 'conditionStatus',
      label: '',
      component: 'radio',
      inlineLabelRows: true,
      options: [
        { label: 'Condition of the above vehicle is satisfactory.', id: 'satisfactory' },
        {
          label: 'Condition of the above vehicle is NOT satisfactory. (Out of Service/Red Tag)',
          id: 'not_satisfactory',
          disabled: true
        }
      ]
    },
    {
      name: 'pictures',
      label: 'Pictures',
      component: 'imagePicker',
      accept: '.png,.jpg,.jpeg,image/png,image/jpeg',
      maxSize: MAX_DVIR_IMAGE_SIZE
    },
    { name: 'driverName', label: 'Driver Name', component: 'input' },
    { name: 'signatureData', label: 'Driver Signature', component: 'signaturePad' }
  ]
};
